module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Actions")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.items), function(item) {
    return _c('p', [_vm._v(" \n    \t" + _vm._s(item.name) + " attacked with "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v(_vm._s(item.attack))]), _c('br'), _vm._v("\n    \tdamage caused: "), _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(item.damage))]), _vm._v(" "), _c('br'), _c('b', [_vm._v(_vm._s(item.desc ? item.desc : ''))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4209470","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/battle/actions/index.vue
// module id = 126
// module chunks = 1